import api from "./api";

// Categorias de chamado (catalogo por empresa) — listbox na edicao + tela de cadastro.
const ticketCategoriesService = {
  list: (includeInactive = false) =>
    api
      .get("/ticket-categories", { params: includeInactive ? { include_inactive: true } : {} })
      .then((r) => r.data),
  create: (name) => api.post("/ticket-categories", { name }).then((r) => r.data),
  update: (id, payload) => api.put(`/ticket-categories/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/ticket-categories/${id}`).then((r) => r.data),
};

export default ticketCategoriesService;
